/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDerivativesOrderRequest } from '../models/CreateDerivativesOrderRequest';
import type { DerivativesOrderProjection } from '../models/DerivativesOrderProjection';
import type { DerivativesOrderStatus } from '../models/DerivativesOrderStatus';
import type { EntityCreatedResponse } from '../models/EntityCreatedResponse';
import type { UpdateDerivativesOrderRequest } from '../models/UpdateDerivativesOrderRequest';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class DerivativesOrdersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns EntityCreatedResponse Created
     * @throws ApiError
     */
    public postV1DerivativesOrders(
        requestBody?: CreateDerivativesOrderRequest,
    ): CancelablePromise<EntityCreatedResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/derivatives/orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param tradingPairCode
     * @param statuses
     * @param openedPositionId
     * @param settlementCurrency
     * @param skip
     * @param take
     * @returns DerivativesOrderProjection Success
     * @throws ApiError
     */
    public getV1DerivativesOrders(
        tradingPairCode?: string,
        statuses?: Array<DerivativesOrderStatus>,
        openedPositionId?: number,
        settlementCurrency?: string,
        skip?: number,
        take?: number,
    ): CancelablePromise<Array<DerivativesOrderProjection>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/derivatives/orders',
            query: {
                'tradingPairCode': tradingPairCode,
                'statuses': statuses,
                'openedPositionId': openedPositionId,
                'settlementCurrency': settlementCurrency,
                'skip': skip,
                'take': take,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putV1DerivativesOrders(
        orderId: number,
        requestBody?: UpdateDerivativesOrderRequest,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/derivatives/orders/{orderId}',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param orderId
     * @returns void
     * @throws ApiError
     */
    public deleteV1DerivativesOrders(
        orderId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/derivatives/orders/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
}
